(() => {
    const SELECTOR = '[data-amara-product-faq]';

    function initProductFaq(section) {
        if (!section || section.dataset.amaraProductFaqReady === 'true') return;

        section.dataset.amaraProductFaqReady = 'true';
        section.classList.add('js-ready');

        const items = [
            ...section.querySelectorAll('[data-amara-product-faq-item]')
        ];

        const prefersReducedMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
        ).matches;

        function getParts(item) {
            return {
                trigger: item.querySelector('[data-amara-product-faq-trigger]'),
                panel: item.querySelector('[data-amara-product-faq-panel]')
            };
        }

        function openItem(item) {
            const { trigger, panel } = getParts(item);

            if (!trigger || !panel) return;
            if (trigger.getAttribute('aria-expanded') === 'true') return;

            items.forEach((otherItem) => {
                if (otherItem !== item) {
                    closeItem(otherItem);
                }
            });

            trigger.setAttribute('aria-expanded', 'true');

            panel.setAttribute('aria-hidden', 'false');

            item.classList.add('is-open');
            panel.classList.add('is-open');

            if (prefersReducedMotion) {
                panel.style.height = 'auto';
                return;
            }

            panel.style.height = '0px';

            requestAnimationFrame(() => {
                panel.style.height = `${panel.scrollHeight}px`;

                const onEnd = (event) => {
                    if (event.propertyName !== 'height') return;

                    panel.removeEventListener('transitionend', onEnd);

                    if (trigger.getAttribute('aria-expanded') === 'true') {
                        panel.style.height = 'auto';
                    }
                };

                panel.addEventListener('transitionend', onEnd);
            });
        }

        function closeItem(item) {
            const { trigger, panel } = getParts(item);

            if (!trigger || !panel) return;
            if (trigger.getAttribute('aria-expanded') !== 'true') return;

            trigger.setAttribute('aria-expanded', 'false');

            item.classList.remove('is-open');
            panel.classList.remove('is-open');

            if (prefersReducedMotion) {
                panel.style.height = '0px';
                panel.setAttribute('aria-hidden', 'true');
                return;
            }

            panel.style.height = `${panel.scrollHeight}px`;

            requestAnimationFrame(() => {
                panel.style.height = '0px';

                const onEnd = (event) => {
                    if (event.propertyName !== 'height') return;

                    panel.removeEventListener('transitionend', onEnd);

                    if (trigger.getAttribute('aria-expanded') === 'false') {
                        panel.setAttribute('aria-hidden', 'true');
                    }
                };

                panel.addEventListener('transitionend', onEnd);
            });
        }

        items.forEach((item) => {
            const { trigger } = getParts(item);

            if (!trigger) return;

            trigger.addEventListener('click', () => {
                const expanded =
                    trigger.getAttribute('aria-expanded') === 'true';

                if (expanded) {
                    closeItem(item);
                } else {
                    openItem(item);
                }
            });
        });


        /* Entrance reveal */

        const revealElements = [
            ...section.querySelectorAll('[data-amara-product-faq-reveal]')
        ];

        if (
            prefersReducedMotion ||
            !('IntersectionObserver' in window)
        ) {
            revealElements.forEach((element) => {
                element.classList.add('is-visible');
            });

            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) return;

                    const element = entry.target;

                    const itemIndex = items.indexOf(element);

                    if (itemIndex >= 0) {
                        element.style.transitionDelay = `${itemIndex * 50}ms`;
                    }

                    element.classList.add('is-visible');

                    observer.unobserve(element);
                });
            },
            {
                threshold: 0.12,
                rootMargin: '0px 0px -7% 0px'
            }
        );

        revealElements.forEach((element) => {
            observer.observe(element);
        });
    }


    function scan(root = document) {
        if (root.matches?.(SELECTOR)) {
            initProductFaq(root);
        }

        root.querySelectorAll?.(SELECTOR).forEach(initProductFaq);
    }


    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => scan());
    } else {
        scan();
    }


    document.addEventListener(
        'shopify:section:load',
        (event) => {
            scan(event.target);
        }
    );
})();